var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.364 13.5577C22.5605 14.369 21.4598 15.1624 21.4601 16.3043L21.4614 21.2233C21.4811 22.5488 20.5073 23.8416 19.1432 23.9596C18.0827 24.0516 16.9213 23.9438 15.8078 23.9357C15.1898 23.9313 14.3605 23.9417 14.2939 23.3273C14.1035 21.5465 14.4393 19.4331 14.2958 17.6186C14.2526 17.0706 13.9093 16.5582 13.3295 16.4786C12.7816 16.4036 11.3265 16.4205 10.7561 16.473C10.1857 16.5254 9.79261 16.9404 9.70911 17.4856C9.56839 19.3488 9.87892 21.4472 9.70536 23.2823C9.6451 23.9247 8.79409 23.9279 8.1489 23.9344C7.03279 23.9456 5.86141 24.0597 4.8091 23.9577C3.4938 23.8303 2.51624 22.5516 2.53501 21.2701L2.53647 15.7839C2.5367 14.9213 1.77772 14.3238 1.04146 13.8744C-0.210049 13.109 -0.347021 11.3657 0.685893 10.3465L10.3602 0.687471C11.2721 -0.227751 12.7253 -0.230562 13.64 0.687471L23.288 10.3221C24.1849 11.198 24.2609 12.6509 23.364 13.5577Z",
    fill: "url(#paint0_linear_1105_2565)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1105_2565",
    x1: 1.67951,
    y1: 5.99995,
    x2: 23.5968,
    y2: 6.45969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/Home-logo.e092c7e79e5743824f50660274e94d48.svg";
export { ForwardRef as ReactComponent };